import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunityTypeLookupComponent } from './community-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [CommunityTypeLookupComponent],
  exports: [CommunityTypeLookupComponent]
})
export class CommunityTypeLookupModule { }
